import ShowGasBrandMerchant from "./showGasBrandMerchant.js";
import {
  EditGasBrandMerchantFuel,
  EditGasBrandMerchantInfo,
} from "./editGasBrandMerchant.js";
import CreateGasBrandMerchant from "./createGasBrandMerchant.js";

export default {
  ShowGasBrandMerchant,
  EditGasBrandMerchantFuel,
  EditGasBrandMerchantInfo,
  CreateGasBrandMerchant,
};
